import httpClient from '../httpClient';

export async function getAllOrgInterPlanoTrabalho() {
  try {
    const response = await httpClient.get(`/api/orginter-planotrabalho`);

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter dados:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function getOrgInterPlanoTrabalho(id: string) {
  try {
    const response = await httpClient.get(`/api/orginter-planotrabalho/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getPlanoTrabalhoPorOrgInter(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-planotrabalho/orginter/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getProdutoPorPlanoTrabalho(orgInter: string) {
  if (!orgInter) return;
  try {
    const response = await httpClient.get(
      `/api/orginter-planotrabalho/produtos/${orgInter}`,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao obter lista:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}
